import { ValidBusinessObject } from '@iotv/iotv-v3-types'
import { NodeEdgeMapper } from '../../model/constructs'

export { camelToDisplay, noSpace, capitalize, toCamelCase } from '@iotv/core-services'

/** Takes a node and a nem and constructs a full name based on "parent / parent / node" using links found in nem
 * e.g. property1 -> area1 -> area2
 *  - area2 returns "property1 / area1 / area2"
 *  - area1 returns "property1 / area1"
 *
 * @param node - The node who's name to get. Always included
 * @param nem - THe node edge mapper containing relationships to construct the name by
 * @param typeFilter - Optional filter on types of parent. Base node always included
 * @returns A constructed full name of the node of the form "parent / node"
 * */
export const constructFullName = (node: ValidBusinessObject, nem: NodeEdgeMapper<ValidBusinessObject>, typeFilter?: string[]) => {
  let parentNodes = nem.getAscendents([node])
  let nodesForName: ValidBusinessObject[] = [node]

  let fullName = ''
  for (let i = parentNodes.length - 1; i >= 0; i--) {
    const n = parentNodes[i]
    if (typeFilter && !typeFilter.includes(n.type)) break
    nodesForName.unshift(n)
  }
  fullName = nodesForName.map((n) => n.name).join(' / ')
  return fullName
}
